export const menu = {
  input: {
    media: {
      label: 'Audio file IVR'
    },

    wrong: {
      label: 'Invalid choice'
    },

    select_file: 'Select a file | Select files',

    timeout: {
      label: 'Response timeout'
    },

    action: {
      label: 'Click action'
    }
  },

  state: {
    init: {
      description:
        'The IVR voice menu is a circuit element that allows you to flexibly configure different call routing logic through interaction with the subscriber'
    }
  }
};
